var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticStyle:{"display":"flex","justify-content":"center","width":"100%"},attrs:{"id":"toolbar"}}),_c('div',{attrs:{"id":"editor"}})])
}]

export { render, staticRenderFns }